import { UseSuspenseQueryOptions, useMutation, useQueryClient } from '@tanstack/react-query';

import { TextFilters } from '@/module/Author/Text/model/TextTypes';

import { Id, PagedParams, PagedResponse, getQueryKey } from '@feature/utils';

import * as api from './ChapterApi';
import { Chapter, ChapterRequest } from './ChapterTypes';

const chapterKey = getQueryKey('chapter');

export function getChapterPagedOptions(
  params: PagedParams<TextFilters>,
): UseSuspenseQueryOptions<PagedResponse<Chapter>> {
  return {
    queryKey: chapterKey.paged(params),
    queryFn: () => api.getPaged(params),
  };
}

export function getChapterOptions(chapterId: Id): UseSuspenseQueryOptions<Chapter> {
  return {
    queryKey: chapterKey.one(chapterId),
    queryFn: () => api.get(chapterId),
  };
}

export function useChapterEdit(chapterId: Id) {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (request: ChapterRequest) => api.edit(chapterId, request),
    onSuccess: () =>
      queryClient.invalidateQueries({
        queryKey: chapterKey.root(),
      }),
  });
}

export function useChapterCreate() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (request: ChapterRequest) => api.create(request),
    onSuccess: () =>
      queryClient.invalidateQueries({
        queryKey: chapterKey.root(),
      }),
  });
}

export function useChapterDelete(chapterId: Id) {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: () => api.deleteById(chapterId),
    onSuccess: () =>
      queryClient.invalidateQueries({
        queryKey: chapterKey.root(),
      }),
  });
}
